<template>
  <div>
    <Title title="パスワードの変更" />
    <app-button class="default mb-3" @click="openPasswordEditForm">パスワードを変更する</app-button>
    <b-modal id="password-modal" :title="modalTitle" :hide-footer="true" size="lg">
      <PasswordEdit @update="update" @closeModal="closePasswordEditForm"></PasswordEdit>
    </b-modal>
  </div>
</template>

<script>
import Title from '@/components/Title.vue'
import PasswordEdit from '@/components/PasswordEdit.vue'
import AppButton from '@/components/presentationals/AppButton'

export default {
  name: 'Config',
  components: {
    Title,
    PasswordEdit,
    AppButton
  },
  data() {
    return {
      modalTitle: 'パスワードの変更'
    }
  },
  methods: {
    async openPasswordEditForm() {
      this.modalTitle = 'パスワードの変更'
      this.$nextTick().then((e) => {
        this.$bvModal.show('password-modal')
      })
    },
    closePasswordEditForm() {
      this.$bvModal.hide('password-modal')
    },
    update() {}
  }
}
</script>
